import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, InputAdornment, Box } from '@mui/material';
import { ReportProblemOutlined } from '@mui/icons-material';
import { useFacilityMaintenanceEditor } from '../../../../../hooks/useFacilityMaintenanceEditor';
import { useGetIssueTypesQuery } from '../../../../../../../services/DimensionService/dimensionApi';
import { EditorMode } from '../../../../../types/editorTypes';

interface Props {
  mode: EditorMode;
}

export const FacilityMaintenanceIssueTypeEditor: React.FC<Props> = ({ mode }) => {
  const { request, updateRequest } = useFacilityMaintenanceEditor(mode);
  const { data: issueTypes = [], isLoading } = useGetIssueTypesQuery();
  const labelId = `${mode}-facility-issue-type-label`;

  const handleChange = (value: string) => {
    updateRequest({ issueType: value });
  };

  return (
    <Box sx={{ flex: 1 }}>
      <FormControl size="small" fullWidth required>
        <InputLabel id={labelId}>Issue Type</InputLabel>
        <Select
          labelId={labelId}
          value={request?.issueType || ''}
          onChange={(e) => handleChange(e.target.value)}
          label="Issue Type"
          disabled={isLoading}
          startAdornment={
            <InputAdornment position="start">
              <ReportProblemOutlined sx={{ color: '#64748b', fontSize: 18 }} />
            </InputAdornment>
          }
        >
          {issueTypes.map((type) => (
            <MenuItem key={type.value} value={type.value}>
              {type.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default FacilityMaintenanceIssueTypeEditor;
